module.exports = __webpack_public_path__ + "img/banner-campari-2.003d9984.jpg";